/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { CalibrationBlockOptionDto } from '../models/calibration-block-option-dto';
import { CalibrationBlockOptionDtoDlmBaseResponse } from '../models/calibration-block-option-dto-dlm-base-response';
import { CalibrationBlockOptionDtoListDlmBaseResponse } from '../models/calibration-block-option-dto-list-dlm-base-response';
import { CalibrationCertFileDto } from '../models/calibration-cert-file-dto';
import { CalibrationCertFileDtoDlmBaseResponse } from '../models/calibration-cert-file-dto-dlm-base-response';
import { CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse } from '../models/calibration-cert-file-dto-dlm-paged-response-dlm-base-response';
import { CalibrationCertFileDtoListDlmBaseResponse } from '../models/calibration-cert-file-dto-list-dlm-base-response';
import { CalibrationResponse } from '../models/calibration-response';
import { CalibrationResponseDlmBaseResponse } from '../models/calibration-response-dlm-base-response';
import { MachineRating } from '../models/machine-rating';
import { MachineResponseDlmBaseResponse } from '../models/machine-response-dlm-base-response';
import { OrderDirection } from '../models/order-direction';
import { ResultInformationListDlmBaseResponse } from '../models/result-information-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class CalibrationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiCalibrationPingGet
   */
  static readonly ApiCalibrationPingGetPath = '/api/Calibration/ping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationPingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationPingGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationPingGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationPingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationPingGet$Plain(params?: {
  }): Observable<BooleanBaseResponse> {

    return this.apiCalibrationPingGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationPingGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationPingGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationPingGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationPingGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationPingGet$Json(params?: {
  }): Observable<BooleanBaseResponse> {

    return this.apiCalibrationPingGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationCalibrationGet
   */
  static readonly ApiCalibrationCalibrationGetPath = '/api/Calibration/calibration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationCalibrationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationGet$Plain$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationCalibrationGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationCalibrationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationGet$Plain(params?: {
    calibrationId?: number;
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationCalibrationGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationCalibrationGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationGet$Json$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationCalibrationGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationCalibrationGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationGet$Json(params?: {
    calibrationId?: number;
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationCalibrationGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationCalibrationPost
   */
  static readonly ApiCalibrationCalibrationPostPath = '/api/Calibration/calibration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationCalibrationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationCalibrationPost$Plain$Response(params?: {
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationCalibrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationCalibrationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationCalibrationPost$Plain(params?: {
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationCalibrationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationCalibrationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationCalibrationPost$Json$Response(params?: {
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationCalibrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationCalibrationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationCalibrationPost$Json(params?: {
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationCalibrationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationGetArchivedResultsGet
   */
  static readonly ApiCalibrationGetArchivedResultsGetPath = '/api/Calibration/get-archived-results';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationGetArchivedResultsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetArchivedResultsGet$Plain$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<ResultInformationListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationGetArchivedResultsGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResultInformationListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationGetArchivedResultsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetArchivedResultsGet$Plain(params?: {
    calibrationId?: number;
  }): Observable<ResultInformationListDlmBaseResponse> {

    return this.apiCalibrationGetArchivedResultsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ResultInformationListDlmBaseResponse>) => r.body as ResultInformationListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationGetArchivedResultsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetArchivedResultsGet$Json$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<ResultInformationListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationGetArchivedResultsGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResultInformationListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationGetArchivedResultsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetArchivedResultsGet$Json(params?: {
    calibrationId?: number;
  }): Observable<ResultInformationListDlmBaseResponse> {

    return this.apiCalibrationGetArchivedResultsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ResultInformationListDlmBaseResponse>) => r.body as ResultInformationListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationReinstateResultGet
   */
  static readonly ApiCalibrationReinstateResultGetPath = '/api/Calibration/reinstate-result';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationReinstateResultGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationReinstateResultGet$Plain$Response(params?: {
    resultId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationReinstateResultGetPath, 'get');
    if (params) {
      rb.query('resultId', params.resultId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationReinstateResultGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationReinstateResultGet$Plain(params?: {
    resultId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationReinstateResultGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationReinstateResultGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationReinstateResultGet$Json$Response(params?: {
    resultId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationReinstateResultGetPath, 'get');
    if (params) {
      rb.query('resultId', params.resultId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationReinstateResultGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationReinstateResultGet$Json(params?: {
    resultId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationReinstateResultGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationEditCalibrationPost
   */
  static readonly ApiCalibrationEditCalibrationPostPath = '/api/Calibration/edit-calibration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationEditCalibrationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationPost$Plain$Response(params?: {
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationEditCalibrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationEditCalibrationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationPost$Plain(params?: {
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationEditCalibrationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationEditCalibrationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationPost$Json$Response(params?: {
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationEditCalibrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationEditCalibrationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationPost$Json(params?: {
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationEditCalibrationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationDeleteEquipmentPost
   */
  static readonly ApiCalibrationDeleteEquipmentPostPath = '/api/Calibration/delete-equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDeleteEquipmentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteEquipmentPost$Plain$Response(params?: {
    equipmentId?: number;
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDeleteEquipmentPostPath, 'post');
    if (params) {
      rb.query('equipmentId', params.equipmentId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDeleteEquipmentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteEquipmentPost$Plain(params?: {
    equipmentId?: number;
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationDeleteEquipmentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDeleteEquipmentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteEquipmentPost$Json$Response(params?: {
    equipmentId?: number;
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDeleteEquipmentPostPath, 'post');
    if (params) {
      rb.query('equipmentId', params.equipmentId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDeleteEquipmentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteEquipmentPost$Json(params?: {
    equipmentId?: number;
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationDeleteEquipmentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationDeleteResultPost
   */
  static readonly ApiCalibrationDeleteResultPostPath = '/api/Calibration/delete-result';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDeleteResultPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteResultPost$Plain$Response(params?: {
    resultId?: number;
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDeleteResultPostPath, 'post');
    if (params) {
      rb.query('resultId', params.resultId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDeleteResultPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteResultPost$Plain(params?: {
    resultId?: number;
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationDeleteResultPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDeleteResultPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteResultPost$Json$Response(params?: {
    resultId?: number;
    body?: CalibrationResponse
  }): Observable<StrictHttpResponse<CalibrationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDeleteResultPostPath, 'post');
    if (params) {
      rb.query('resultId', params.resultId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDeleteResultPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationDeleteResultPost$Json(params?: {
    resultId?: number;
    body?: CalibrationResponse
  }): Observable<CalibrationResponseDlmBaseResponse> {

    return this.apiCalibrationDeleteResultPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationResponseDlmBaseResponse>) => r.body as CalibrationResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationDefaultMachineGet
   */
  static readonly ApiCalibrationDefaultMachineGetPath = '/api/Calibration/default-machine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDefaultMachineGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDefaultMachineGet$Plain$Response(params?: {

    /**
     * 1 &#x3D; One
     * 
     * 2 &#x3D; Sixty
     * 
     * 3 &#x3D; OneHundred
     * 
     * 4 &#x3D; ThreeThousand
     * 
     * 5 &#x3D; Other
     * 
     * 6 &#x3D; Ninety
     */
    machineRating?: MachineRating;
  }): Observable<StrictHttpResponse<MachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDefaultMachineGetPath, 'get');
    if (params) {
      rb.query('machineRating', params.machineRating, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDefaultMachineGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDefaultMachineGet$Plain(params?: {

    /**
     * 1 &#x3D; One
     * 
     * 2 &#x3D; Sixty
     * 
     * 3 &#x3D; OneHundred
     * 
     * 4 &#x3D; ThreeThousand
     * 
     * 5 &#x3D; Other
     * 
     * 6 &#x3D; Ninety
     */
    machineRating?: MachineRating;
  }): Observable<MachineResponseDlmBaseResponse> {

    return this.apiCalibrationDefaultMachineGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MachineResponseDlmBaseResponse>) => r.body as MachineResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDefaultMachineGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDefaultMachineGet$Json$Response(params?: {

    /**
     * 1 &#x3D; One
     * 
     * 2 &#x3D; Sixty
     * 
     * 3 &#x3D; OneHundred
     * 
     * 4 &#x3D; ThreeThousand
     * 
     * 5 &#x3D; Other
     * 
     * 6 &#x3D; Ninety
     */
    machineRating?: MachineRating;
  }): Observable<StrictHttpResponse<MachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDefaultMachineGetPath, 'get');
    if (params) {
      rb.query('machineRating', params.machineRating, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDefaultMachineGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDefaultMachineGet$Json(params?: {

    /**
     * 1 &#x3D; One
     * 
     * 2 &#x3D; Sixty
     * 
     * 3 &#x3D; OneHundred
     * 
     * 4 &#x3D; ThreeThousand
     * 
     * 5 &#x3D; Other
     * 
     * 6 &#x3D; Ninety
     */
    machineRating?: MachineRating;
  }): Observable<MachineResponseDlmBaseResponse> {

    return this.apiCalibrationDefaultMachineGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MachineResponseDlmBaseResponse>) => r.body as MachineResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationIsCertFileStaleGet
   */
  static readonly ApiCalibrationIsCertFileStaleGetPath = '/api/Calibration/is-cert-file-stale';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationIsCertFileStaleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationIsCertFileStaleGet$Plain$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationIsCertFileStaleGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationIsCertFileStaleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationIsCertFileStaleGet$Plain(params?: {
    calibrationId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationIsCertFileStaleGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationIsCertFileStaleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationIsCertFileStaleGet$Json$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationIsCertFileStaleGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationIsCertFileStaleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationIsCertFileStaleGet$Json(params?: {
    calibrationId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationIsCertFileStaleGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationGetCertFilesGet
   */
  static readonly ApiCalibrationGetCertFilesGetPath = '/api/Calibration/get-cert-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationGetCertFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetCertFilesGet$Plain$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationGetCertFilesGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationGetCertFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetCertFilesGet$Plain(params?: {
    calibrationId?: number;
  }): Observable<CalibrationCertFileDtoListDlmBaseResponse> {

    return this.apiCalibrationGetCertFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoListDlmBaseResponse>) => r.body as CalibrationCertFileDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationGetCertFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetCertFilesGet$Json$Response(params?: {
    calibrationId?: number;
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationGetCertFilesGetPath, 'get');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationGetCertFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetCertFilesGet$Json(params?: {
    calibrationId?: number;
  }): Observable<CalibrationCertFileDtoListDlmBaseResponse> {

    return this.apiCalibrationGetCertFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoListDlmBaseResponse>) => r.body as CalibrationCertFileDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationGetPaginatedCertFilesForSerialNumberGet
   */
  static readonly ApiCalibrationGetPaginatedCertFilesForSerialNumberGetPath = '/api/Calibration/get-paginated-cert-files-for-serial-number';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Plain$Response(params?: {
    OrderProperty?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
    SerialNumber?: string;
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationGetPaginatedCertFilesForSerialNumberGetPath, 'get');
    if (params) {
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('Order', params.Order, {});
      rb.query('SerialNumber', params.SerialNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Plain(params?: {
    OrderProperty?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
    SerialNumber?: string;
  }): Observable<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse> {

    return this.apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Json$Response(params?: {
    OrderProperty?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
    SerialNumber?: string;
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationGetPaginatedCertFilesForSerialNumberGetPath, 'get');
    if (params) {
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('Order', params.Order, {});
      rb.query('SerialNumber', params.SerialNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Json(params?: {
    OrderProperty?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
    SerialNumber?: string;
  }): Observable<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse> {

    return this.apiCalibrationGetPaginatedCertFilesForSerialNumberGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationUploadCertFileCalibrationIdPost
   */
  static readonly ApiCalibrationUploadCertFileCalibrationIdPostPath = '/api/Calibration/upload-cert-file/{calibrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationUploadCertFileCalibrationIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCalibrationUploadCertFileCalibrationIdPost$Plain$Response(params: {
    calibrationId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationUploadCertFileCalibrationIdPostPath, 'post');
    if (params) {
      rb.path('calibrationId', params.calibrationId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationUploadCertFileCalibrationIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCalibrationUploadCertFileCalibrationIdPost$Plain(params: {
    calibrationId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<CalibrationCertFileDtoDlmBaseResponse> {

    return this.apiCalibrationUploadCertFileCalibrationIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationUploadCertFileCalibrationIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCalibrationUploadCertFileCalibrationIdPost$Json$Response(params: {
    calibrationId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationUploadCertFileCalibrationIdPostPath, 'post');
    if (params) {
      rb.path('calibrationId', params.calibrationId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationUploadCertFileCalibrationIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiCalibrationUploadCertFileCalibrationIdPost$Json(params: {
    calibrationId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<CalibrationCertFileDtoDlmBaseResponse> {

    return this.apiCalibrationUploadCertFileCalibrationIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationUpdateCertFilePost
   */
  static readonly ApiCalibrationUpdateCertFilePostPath = '/api/Calibration/update-cert-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationUpdateCertFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationUpdateCertFilePost$Plain$Response(params?: {
    body?: CalibrationCertFileDto
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationUpdateCertFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationUpdateCertFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationUpdateCertFilePost$Plain(params?: {
    body?: CalibrationCertFileDto
  }): Observable<CalibrationCertFileDtoDlmBaseResponse> {

    return this.apiCalibrationUpdateCertFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationUpdateCertFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationUpdateCertFilePost$Json$Response(params?: {
    body?: CalibrationCertFileDto
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationUpdateCertFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationUpdateCertFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationUpdateCertFilePost$Json(params?: {
    body?: CalibrationCertFileDto
  }): Observable<CalibrationCertFileDtoDlmBaseResponse> {

    return this.apiCalibrationUpdateCertFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationDownloadCertFileFileIdGet
   */
  static readonly ApiCalibrationDownloadCertFileFileIdGetPath = '/api/Calibration/download-cert-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDownloadCertFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDownloadCertFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDownloadCertFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDownloadCertFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDownloadCertFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiCalibrationDownloadCertFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiCalibrationDeleteCertFileFileIdDelete
   */
  static readonly ApiCalibrationDeleteCertFileFileIdDeletePath = '/api/Calibration/delete-cert-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDeleteCertFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDeleteCertFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDeleteCertFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDeleteCertFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDeleteCertFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<CalibrationCertFileDtoDlmBaseResponse> {

    return this.apiCalibrationDeleteCertFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationDeleteCertFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDeleteCertFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationDeleteCertFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationDeleteCertFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationDeleteCertFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<CalibrationCertFileDtoDlmBaseResponse> {

    return this.apiCalibrationDeleteCertFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationCertFileDtoDlmBaseResponse>) => r.body as CalibrationCertFileDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationCalibrationBlocksGet
   */
  static readonly ApiCalibrationCalibrationBlocksGetPath = '/api/Calibration/calibration-blocks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationCalibrationBlocksGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationBlocksGet$Plain$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<CalibrationBlockOptionDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationCalibrationBlocksGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationBlockOptionDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationCalibrationBlocksGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationBlocksGet$Plain(params?: {
    archived?: boolean;
  }): Observable<CalibrationBlockOptionDtoListDlmBaseResponse> {

    return this.apiCalibrationCalibrationBlocksGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationBlockOptionDtoListDlmBaseResponse>) => r.body as CalibrationBlockOptionDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationCalibrationBlocksGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationBlocksGet$Json$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<CalibrationBlockOptionDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationCalibrationBlocksGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationBlockOptionDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationCalibrationBlocksGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationCalibrationBlocksGet$Json(params?: {
    archived?: boolean;
  }): Observable<CalibrationBlockOptionDtoListDlmBaseResponse> {

    return this.apiCalibrationCalibrationBlocksGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationBlockOptionDtoListDlmBaseResponse>) => r.body as CalibrationBlockOptionDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationAddCalibrationBlockPost
   */
  static readonly ApiCalibrationAddCalibrationBlockPostPath = '/api/Calibration/add-calibration-block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationAddCalibrationBlockPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationAddCalibrationBlockPost$Plain$Response(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<StrictHttpResponse<CalibrationBlockOptionDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationAddCalibrationBlockPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationBlockOptionDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationAddCalibrationBlockPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationAddCalibrationBlockPost$Plain(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<CalibrationBlockOptionDtoDlmBaseResponse> {

    return this.apiCalibrationAddCalibrationBlockPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationBlockOptionDtoDlmBaseResponse>) => r.body as CalibrationBlockOptionDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationAddCalibrationBlockPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationAddCalibrationBlockPost$Json$Response(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<StrictHttpResponse<CalibrationBlockOptionDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationAddCalibrationBlockPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationBlockOptionDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationAddCalibrationBlockPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationAddCalibrationBlockPost$Json(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<CalibrationBlockOptionDtoDlmBaseResponse> {

    return this.apiCalibrationAddCalibrationBlockPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationBlockOptionDtoDlmBaseResponse>) => r.body as CalibrationBlockOptionDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationEditCalibrationBlockPut
   */
  static readonly ApiCalibrationEditCalibrationBlockPutPath = '/api/Calibration/edit-calibration-block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationEditCalibrationBlockPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationBlockPut$Plain$Response(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationEditCalibrationBlockPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationEditCalibrationBlockPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationBlockPut$Plain(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationEditCalibrationBlockPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationEditCalibrationBlockPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationBlockPut$Json$Response(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationEditCalibrationBlockPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationEditCalibrationBlockPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCalibrationEditCalibrationBlockPut$Json(params?: {
    body?: CalibrationBlockOptionDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationEditCalibrationBlockPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationArchiveCalibrationBlockDelete
   */
  static readonly ApiCalibrationArchiveCalibrationBlockDeletePath = '/api/Calibration/archive-calibration-block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationArchiveCalibrationBlockDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationArchiveCalibrationBlockDelete$Plain$Response(params?: {
    blockOptionId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationArchiveCalibrationBlockDeletePath, 'delete');
    if (params) {
      rb.query('blockOptionId', params.blockOptionId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationArchiveCalibrationBlockDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationArchiveCalibrationBlockDelete$Plain(params?: {
    blockOptionId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationArchiveCalibrationBlockDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationArchiveCalibrationBlockDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationArchiveCalibrationBlockDelete$Json$Response(params?: {
    blockOptionId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationService.ApiCalibrationArchiveCalibrationBlockDeletePath, 'delete');
    if (params) {
      rb.query('blockOptionId', params.blockOptionId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationArchiveCalibrationBlockDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationArchiveCalibrationBlockDelete$Json(params?: {
    blockOptionId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCalibrationArchiveCalibrationBlockDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
